import React from "react";

import { Grid, Typography } from "@material-ui/core";

import OutboxCli from "../../sdk/OutboxCli";

export class ImageViewer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // Draft document internal identifier
      documentid: null,

      // Number document page requested to be displayed
      pagenumber: 1,

      // Total number document pages 
      totalpages: 1,

      // Image content represents in base64 format
      base64: "",

      // Width and height in pixels given to the viewer. The displayed background image will be resized to this width and heigth.
      viewerWidth: 0,
      viewerHeight: 0,

      //error message to display in case of api calls fail
      errormessage: null,

      isLoading: false
    }
  }
  
  componentDidMount() {
    if (this.props) {
      this.setState({
        documentid: this.props.documentid,
        pagenumber: this.props.pagenumber,
        totalpages: this.props.totalpages,
        viewerWidth: this.props.viewerWidth,
        viewerHeight: this.props.viewerHeight
      },
        () => {
          this.getPage()
          this.props.handleisLoadingDraft()
        })
    }
  }

  /**
   * Returns base64 of a page and draft requested
   */
  getPage = () => {

    this.setState({ isLoading: true })

    OutboxCli.GetDraftPageImage(this.state.documentid, this.state.pagenumber, 0, 0, 100, 100).then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ errormessage: response.substring(response.indexOf(' ')) })
      } else {
        this.setState({ base64: response, errormessage: null })
      }

      this.setState({ isLoading: false })
    })
  }

  /**
   * Loading the previous page that it has to be displayed. If it is in the first page, it doesnt do anything
   */
  previousPage = () => {
    if (this.state.pagenumber > 1) {
      let pagenumber = this.state.pagenumber
      this.setState({ pagenumber: --pagenumber },
        () => {
          this.getPage(this.state.documentid, this.state.pagenumber)
          this.props.getCurrentPage(this.state.pagenumber, "PREVIOUS")
        }
      )
    }
  }

  /**
   * Loading the next page that it has to be displayed. If there are no more pages, it doesnt do anything
   */
  nextPage = () => {
    if (this.state.pagenumber < this.state.totalpages) {
      let pagenumber = this.state.pagenumber
      this.setState({ pagenumber: ++pagenumber },
        () => {
          this.getPage(this.state.documentid, this.state.pagenumber)
          this.props.getCurrentPage(this.state.pagenumber, "NEXT")
        }
      )
    }
  }
  
  render() {
    return (
      <React.Fragment>

        <Grid container direction="row" spacing={2} alignItems="center" justify="center">

          <Grid container item md={12} justify="center">
            <img className="viewer-container" src={"data:image/png;base64, " + this.state.base64} alt="" width={this.state.viewerWidth} height={this.state.viewerHeight}></img>
          </Grid>
          <Grid container item md={12} justify="center">
            <i className="fa-solid fa-caret-left font-size-25 cursor-pointer" onClick={this.previousPage}></i>
            <Typography className="typography-generic"> {"Página " + this.state.pagenumber + " de " + this.state.totalpages} </Typography>
            <i className="fa-solid fa-caret-right font-size-25 cursor-pointer" onClick={this.nextPage}></i>
          </Grid>

        </Grid>

      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Utilities/ImageViewer.js